import React, { useState, useEffect } from "react";
// ANT DESIGN COMPONENTS
import { Select } from "antd";
// FONT AWESOME LIBRARY AND ICONS
import { faPlus, faPen } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// REDUX
import { useGetStatesMutation } from "../../../redux/countriesStatesCitiesAPI";
// INTERFACES
import { FormularyRowSelectStateInterface } from "../../../interfaces/FormularyRow";

export default function FormularyRowSelectState({
  record,
  text,
  value,
  inputIcon,
  formAction,
  itemId,
  textLink,
  onChangeFormValue,
  country,
}: FormularyRowSelectStateInterface) {
  // ************************************************ */
  // GLOBAL VARIABLES ******************************* */
  const { Option } = Select;

  // ************************************************ */
  // USE STATE VARIABLES **************************** */
  const [listStates, setListStates] = useState<any[]>([]);

  // ************************************************ */
  // REDUX SLICE VARIABLES ************************** */

  // ************************************************ */
  // CUSTOM HOOKS *********************************** */

  // ************************************************ */
  // SERVICES AND API CALLS ************************* */
  const [triggerGetStates, { data, reset: resetGetStates }] = useGetStatesMutation();

  // ************************************************ */
  // FUNCTIONS ************************************** */

  // ************************************************ */
  // USE EFFECT ************************************* */
  // eslint-disable-next-line arrow-body-style
  useEffect(() => {
    return () => {
      resetGetStates();
    };
  }, []);

  useEffect(() => {
    if (
      country &&
      country !== "" &&
      country !== record.country &&
      (record.id === "" || record.id === itemId)
    ) {
      triggerGetStates(country);
    }
  }, [country]);

  useEffect(() => {
    if (data && data.data && data.data.states && data.data.states.length > 0) {
      setListStates(data.data.states);
    }
  }, [data]);

  // ************************************************ */
  // COMPONENT ************************************** */
  return (
    <>
      {record.id === "" ? (
        <Select
          className="generalStyles__width100"
          showSearch
          optionFilterProp="children"
          onChange={(e: any) => {
            onChangeFormValue(e, "state");
          }}
          filterOption={(input: any, option: any) =>
            option.children.toLowerCase().includes(input.toLowerCase())
          }
          size="small"
          value={formAction === "create" ? value : null}
          disabled={country === "" || formAction === "edit"}
          suffixIcon={
            inputIcon ? <FontAwesomeIcon icon={faPlus} className="generalStyles__info" /> : null
          }
        >
          {listStates.map((c: any) => (
            <Option key={c.name} value={c.name}>
              {c.name}
            </Option>
          ))}
        </Select>
      ) : (
        <>
          {formAction === "edit" && record.id === itemId ? (
            <Select
              className="generalStyles__width100"
              showSearch
              optionFilterProp="children"
              onChange={(e: any) => {
                onChangeFormValue(e, "state");
              }}
              filterOption={(input: any, option: any) =>
                option.children.toLowerCase().includes(input.toLowerCase())
              }
              size="small"
              value={value}
              suffixIcon={
                inputIcon ? <FontAwesomeIcon icon={faPen} className="generalStyles__info" /> : null
              }
            >
              {listStates.map((c: any) => (
                <Option key={c.name} value={c.name}>
                  {c.name}
                </Option>
              ))}
            </Select>
          ) : (
            <div className={textLink ? "generalStyles__info" : ""}>{text}</div>
          )}
        </>
      )}
    </>
  );
}
